import { render } from "./ManageRoutesModal.vue?vue&type=template&id=647e028d&scoped=true"
import script from "./ManageRoutesModal.vue?vue&type=script&lang=js"
export * from "./ManageRoutesModal.vue?vue&type=script&lang=js"

import "./ManageRoutesModal.vue?vue&type=style&index=0&id=647e028d&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647e028d"]])

export default __exports__